import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DetailsService } from '../../deleted-letters/details/details.service';
import { filter, Subscription } from 'rxjs';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { StorageService } from 'src/app/core/services/storage.service';
import { RootScopeService } from 'src/app/core/services/root-scope.service';
import { LoginService } from './login.service';
import { LaunchDarklyService } from 'src/app/core/services/launch-darkly.service';
import { OktaAuthStateService } from '@okta/okta-angular';
import { AuthState } from '@okta/okta-auth-js';

@Component({
  selector: 'app-login',
  standalone: false,
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  @Output() subscriptionEmitter = new EventEmitter<Subscription>();
  customers: any[] = [];
  dataLoading = false;
  customerList = new FormControl('', [Validators.required]);
  customerIdSelected: any;
  public customerId:string;
  public source:string;
  isLoading :Boolean = false
  constructor(
    private detailsService: DetailsService,
    private router: Router,
    public storageService: StorageService,
    public rootScope: RootScopeService,
    private loginService: LoginService,
    private rootScopeService: RootScopeService,
    private ldService: LaunchDarklyService,
    private _oktaStateService: OktaAuthStateService,
  ) { }

  async ngOnInit() {
    const getCustomerDetailsSubscription: Subscription = this.detailsService
    .getCustomers()
    .subscribe(response => {
      this.customers = response;
      this.subscriptionEmitter.emit(getCustomerDetailsSubscription);
    });


  }

  loginOKTA() {
    this.loginService.setCredentials(this.customerId, this.source).finally(
      async () => {


        await this.ldService.loadFlags();

        if (this.customerId === 'AutoEmail'|| this.customerId === 'WCMSA') {
          this.router.navigate(['sent-emails']);
        } else {
          this.router.navigate(['entries']);
        }
      }
    );
  }

  private async waitForAuthenticationAndSetCredentials(): Promise<void> {
    return new Promise((resolve, reject) => {
      const timeout = setTimeout(() => {
        console.warn('Authentication timeout - proceeding with anonymous context');
        this.isLoading = false;
        resolve();
      }, 10000); // 10 second timeout

      this._oktaStateService.authState$
        .pipe(filter((s: AuthState) => Boolean(s && s.isAuthenticated)))
        .subscribe(async () => {
          try {
            clearTimeout(timeout);
            // await this.loginService.setCredentials(this.customerId, this.source);
            console.log(' User credentials set successfully');
            resolve();
          } catch (error) {
            console.error(' Failed to set credentials:', error);
            reject(error);
          }
        });
    });
  }
}
